import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { circlePlusStringDark, circlePlusStringTransparent } from "@store/Components/Icons/CirclePlus";
import { TYPOGRAPHY } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(addToListLinkStyles, {
    wrapper: {
        css: css`
            padding: 0;
            margin-top: 0;
            font-size: ${TYPOGRAPHY.size.base};
            font-weight: ${TYPOGRAPHY.weight.bold};

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        {
                            values: [`${TYPOGRAPHY.size.base}`, null, `${TYPOGRAPHY.size.large}`, null, null],
                            properties: ["font-size"],
                        },
                        { values: ["20px 0 10px", null, "0", null, null], properties: ["padding"] },
                        { values: ["100%", null, "auto", null, null], properties: ["width"] },
                    ],
                    mediaOptions.min,
                )}

            ${({ theme }) => breakpointValuesMediaQueries(theme, [], mediaOptions.min)}

            button {
                display: flex;
                align-items: center;

                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: ["auto", null, "0", null, null], properties: ["margin"] }],
                        mediaOptions.min,
                    )}

                &::before {
                    content: "";
                    display: block;
                    width: 1.3em;
                    height: 1.3em;
                    margin-right: 0.5em;
                    font-size: ${TYPOGRAPHY.size.large};
                    background-image: url(${`data:image/svg+xml;base64,${circlePlusStringDark}`});
                    background-repeat: no-repeat;
                    background-size: contain;
                }

                &:hover {
                    &::before {
                        background-image: url(${`data:image/svg+xml;base64,${circlePlusStringTransparent}`});
                    }
                }

                > span {
                    color: ${getColor("text.titles")} !important;
                }
            }
        `,
    },
});
